export const SpaceAtom = ({ v, h }: { v?: number; h?: number }) => {
  return <div style={{ width: h, height: v }}></div>;
};
